import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import Carousel from '@nerdwallet/react-three-tiles/dist/carousel';
import { Impression as BedrockImpression } from '@nerdwallet/analytics/react/impression';
import { CenteredContainer } from '@nerdwallet/react-layout';

// Components
import SmorgasbordTile from './smorgasbord-tile';

const Smorgasbord = ({ className, tiles }) => {
  const renderedTiles = _.map(tiles, (tile, index) => (
    <SmorgasbordTile {...tile} key={`item-${index}`} />
  ));

  return (
    <BedrockImpression entityName="smorgasboard_guides">
      <ElementImpression
        elementDomType="div"
        elementName="Smorgasbord"
        id="smorgasbord"
      >
        <div className={classNames(className, classes('padding-vertical-5'))}>
          <Carousel
            className={classNames([
              'carousel__container',
              classes('display-none--wide'),
            ])}
          >
            {renderedTiles}
          </Carousel>
          <CenteredContainer
            className={classNames([
              'smorga__container',
              classes('padding-vertical-0'),
            ])}
          >
            {renderedTiles}
          </CenteredContainer>
        </div>
      </ElementImpression>
    </BedrockImpression>
  );
};

Smorgasbord.displayName = 'Smorgasbord';

Smorgasbord.propTypes = {
  className: PropTypes.string,
  index: PropTypes.string,
  tiles: PropTypes.arrayOf(PropTypes.shape(Smorgasbord.propTypes)),
};

export default Smorgasbord;
